// extracted by mini-css-extract-plugin
module.exports = {"mProduct":"RB","image":"SB","translucent":"TB","returned":"UB","cancelled":"VB"};